import GeoJSONLayer from '@arcgis/core/layers/GeoJSONLayer';
import type { ArcgisMapView } from '../../LayersTab/utils/arcgisView';

/**
 * Opens a popup for an AOR on the map by querying the AOR layer for the feature
 * and displaying it at the geometry's center or centroid.
 */
export async function openAorPopup(
  mapView: ArcgisMapView,
  aorId: string
): Promise<void> {
  if (!mapView) return;

  const layer = mapView.map.findLayerById('uscg-aors') as GeoJSONLayer;
  if (!layer) return;

  await layer.load();

  const query = layer.createQuery();
  query.where = `id = '${aorId}'`;
  const results = await layer.queryFeatures(query);
  if (results.features.length === 0) return;

  const feature = results.features[0];
  const geometry = feature.geometry;
  if (!geometry?.extent) return;

  const center = geometry.extent.center;
  if (!center || !mapView.popup) return;

  await mapView.openPopup({
    features: [feature],
    location: center,
  });
}
